/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ubb.component.status.service.rpc.UbbComponentStatusServiceExternalRpc
 */

export const getComponentStatusRpc = {
  serviceName: 'com.hubspot.ubb.component.status.service.rpc.UbbComponentStatusServiceExternalRpc',
  rpcName: 'getComponentStatus',
  auth: 'external',
  fingerprint: 'zxaKI_kDF_SqBnkHch_RA61YvUGsL_jy',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};